export function isPositiveInteger(str) {
  return /^\d+$/.test(str);
}

export function checkYmdIsSinceSetUp(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return false;

  const dateArr = dateStr.split('-');
  if (dateArr.length !== 3) return false;

  const year = +dateArr[0];
  const month = +dateArr[1];
  const day = +dateArr[2];

  // 必须是正整数
  if (!isPositiveInteger(year) || !isPositiveInteger(month) || !isPositiveInteger(day)) {
    return false;
  }

  // 必须是合法的日期数字
  if (year < 2004) return false;
  if (month < 1 || month > 12) return false;
  if (day > 31 || day < 1) return false;

  // 闰月最多只有 30 天
  if (![1, 3, 5, 7, 8, 10, 12].includes(month) && day > 30) return false;

  if (month === 2) {
    // 闰年 2 月最多 29 天
    if (day > 29) return false;

    // 平年 2 月最多 28 天
    if (year % 4 !== 0 && day > 28) return false;
  }

  return true;
}

export function checkYmdIsBetweenSetUpAndToday(dateStr = '') {
  if (dateStr.length === 7) dateStr = `${dateStr}-01`;
  return checkYmdIsSinceSetUp(dateStr) && new Date() >= new Date(`${dateStr} 00:00:00`);
}

export function checkYmdIsBetweenSetUpAndNextWeek(dateStr) {
  // 不能超过下周的时间
  const nextWeek = +(new Date()) + 7 * 86400000;
  const checkedDay = +(new Date(dateStr));
  return checkYmdIsSinceSetUp(dateStr) && (checkedDay <= nextWeek);
}
